import React, { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import { ChevronRight, SquareArrowOutUpRight } from "lucide-react";

import ShipmentTag from "../../components/ShipmentTag";
import "react-pdf/dist/Page/TextLayer.css";

export default function WorkflowItem({ workflow }) {
  const navigate = useNavigate();

  // get the nodes of the workflow and sort them based on their index
  const nodes = useMemo(() => {
    return Object.values(workflow.nodes || {}).sort(
      (a, b) => a.index - b.index
    );
  }, [workflow.nodes]);

  return (
    <button
      className="w-full"
      onClick={() => {
        navigate(`/workflows/${workflow.id}`);
      }}
    >
      <div
        id={`workflow:${workflow.id}`}
        className="rounded-xl shadow-lg shadow-gray-50 shadow-opacity-20 border border-gray-200 bg-white pt-3"
      >
        <div className="justify-between flex items-center pl-3 pr-3 space-x-2 text-sm text-gray-800">
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center w-full">
              <ShipmentTag
                maxWidth={400}
                shipment={{
                  container: workflow.name || "No container no.",
                  shipper:
                    workflow.contextObject?.data?.callerName ||
                    workflow.tenant ||
                    "No shipper",
                }}
              />
            </div>
            <div className="flex items-center"></div>
          </div>
          <div
            style={{ fontSize: 10 }}
            className="ml-2 font-normal w-1/3 text-gray-500 flex items-center justify-end"
          >
            <p className="truncate inline float-right mr-2">
              {new Date(workflow.created_at).toDateString()}
            </p>
            <a href={""}>
              <SquareArrowOutUpRight size={12} strokeWidth={2.25} />
            </a>
          </div>
        </div>

        <div className="snippets mt-3 border-t border-gray-200 overflow-hidden divide-gray-100 divide-y">
          <div className="flex items-center px-4 py-3">
            {nodes && (
              <div className="text-xs text-gray-700 font-medium flex items-center flex-1">
                <div className="flex items-center space-x-2 overflow-x-scroll flex-1">
                  {nodes
                    .filter((s) => s.displayTitle)
                    .map((node, index) => {
                      return (
                        <div
                          key={index}
                          className="flex items-center space-x-2"
                        >
                          <div className=""></div>
                          <Tooltip
                            style={{
                              backgroundColor: "rgb(255,255,255)",
                              borderRadius: 8,
                              boxShadow:
                                "0px 3px 6px -3px rgba(211,215,222,0.24)",
                            }}
                            border="1px solid gray"
                            anchorSelect={`#screenshotAnchor-${index}`}
                            content={
                              <div style={{ width: 420, height: 50 }}>
                                <p>Nothing renders here just yet!</p>
                              </div>
                            }
                          />
                          <p
                            id={`screenshotAnchor-${index}`}
                            className={"cursor-pointer"}
                          >
                            {node.displayTitle}
                          </p>
                          {index <
                            nodes.filter((s) => s.displayTitle).length - 1 && (
                            <div className="ml-2">
                              <ChevronRight
                                size={10}
                                color={"rgba(10,10,14,0.35)"}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </div>

          <div className="border-t text-gray-500 text-xs px-4 py-3 flex items-center justify-between w-full">
            <div className="flex items-center space-x-2">
              <div className="font-medium text-gray-600">
                {workflow?.trigger?.config?.jobType
                  ? `Workflow type: ${workflow?.trigger?.config?.jobType}`
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
